import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import { useCreateProcessingEmployeeDataMutation } from "./processingApi";
import useTranslator from "../../../hooks/useTranslator";

export const AddProcessingEmployeeData = ({ show, setShow, record }) => {
  const [addEmployee, { isLoading: isCreating }] =
    useCreateProcessingEmployeeDataMutation();
  const initialFormData = {
    emp_peelers: "",
    emp_suppliers: "",
    emp_cleaners: "",
    emp_supervisors: "",
    emp_putting_fruit_on_trey: "",
    emp_putting_treys_on_cart: "",
  };
  const calculateTotalEmployees = (data) => {
    return (
      Number(data.emp_peelers) +
      Number(data.emp_suppliers) +
      Number(data.emp_cleaners) +
      Number(data.emp_supervisors) +
      Number(data.emp_putting_fruit_on_trey) +
      Number(data.emp_putting_treys_on_cart)
    );
  };

  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    setFormData({
      ...initialFormData,
      ...record, // Automatically fills available record values
    });
  }, [show, record]);
  const { _t } = useTranslator();

  const handleChange = (e) => {
    const updatedFormData = { ...formData, [e.target.name]: e.target.value };
    setFormData(updatedFormData);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const totalEmp = calculateTotalEmployees(formData);

    if (formData.emp_total < totalEmp) {
      toast.error(
        _t(
          "error_employee_total_mismatch",
          "The employee record you entered is incorrect and does not match the total number of employees you entered."
        )
      );
      return;
    }

    try {
      await addEmployee(formData).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("peelers", "Peelers")}
          type="number"
          name="emp_peelers"
          value={formData.emp_peelers}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("suppliers", "Suppliers")}
          type="number"
          name="emp_suppliers"
          value={formData.emp_suppliers}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("putting_treys_on_cart", "Putting treys on cart")}
          type="number"
          name="emp_putting_treys_on_cart"
          value={formData.emp_putting_treys_on_cart}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("putting_fruit_on_trey", "Putting fruit on trey")}
          type="number"
          name="emp_putting_fruit_on_trey"
          value={formData.emp_putting_fruit_on_trey}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("supervisors", "Supervisors")}
          type="number"
          name="emp_supervisors"
          value={formData.emp_supervisors}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("cleaners", "Cleaners")}
          type="number"
          name="emp_cleaners"
          value={formData.emp_cleaners}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("total_persons", "Total Persons")}
          type="number"
          name="emp_total"
          value={calculateTotalEmployees(formData)}
          onChange={handleChange}
          placeholder={"0"}
          disabled={true}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("adding_modal_title", "Adding/Editing Employee Log")}
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
          // isLoading={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};
